// Utility for handling DD/MM/YYYY display format and YYYY-MM-DD input/backend format

export const formatDateToDDMMYYYY = (dateStr) => {
    if (!dateStr) return '';
    const str = String(dateStr).trim();
    if (!str) return '';

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
        return str;
    }

    const cleanStr = str.split('T')[0];
    const parts = cleanStr.split(/[-/]/);
    if (parts.length === 3) {
        if (parts[0].length === 4) {
            // YYYY, MM, DD -> DD/MM/YYYY
            const year = parts[0];
            const month = parts[1].padStart(2, '0');
            const day = parts[2].padStart(2, '0');
            return `${day}/${month}/${year}`;
        }
        if (parts[2].length === 4) {
            // DD, MM, YYYY
            const day = parts[0].padStart(2, '0');
            const month = parts[1].padStart(2, '0');
            const year = parts[2];
            return `${day}/${month}/${year}`;
        }
    }
    return str;
};

export const formatDateToYYYYMMDD = (dateStr) => {
    if (!dateStr) return '';
    const str = String(dateStr).trim();
    if (!str) return '';

    const cleanStr = str.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(cleanStr)) {
        return cleanStr;
    }

    const parts = cleanStr.split(/[-/]/);
    if (parts.length === 3) {
        if (parts[0].length === 4) {
            return `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
        }
        if (parts[2].length === 4) {
            return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
        }
    }
    return str;
};
